"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Types of overview / portfolio fields
 *
 * FIELD - field of entity
 * CALCULATION - custom field
 * COMPONENT - component provided
 * AGGREGATE - grouped by and aggregated field - it's basically ui configurable calculation
 */
var OverviewPortfolioFieldType;
(function (OverviewPortfolioFieldType) {
    OverviewPortfolioFieldType["FIELD"] = "ENTITY_FIELD";
    OverviewPortfolioFieldType["CALCULATION"] = "CALCULATION";
    OverviewPortfolioFieldType["COMPONENT"] = "COMPONENT";
    OverviewPortfolioFieldType["AGGREGATE"] = "AGGREGATE";
})(OverviewPortfolioFieldType = exports.OverviewPortfolioFieldType || (exports.OverviewPortfolioFieldType = {}));
//# sourceMappingURL=overview-field-type.js.map